import isEmpty from "lodash/isEmpty";
import { Dispatch } from "redux";

import { removeElements, addEdge } from "Services/state/journeys/JourneyStateSlice";
import { Edge, Variant } from "Types/Journey";

import { createEdge } from "../JourneyEditPage/Components/JourneyBuilder/shared/helpers";

interface edgeReplacementRecords {
    edgeData?: Edge;
    newHandle?: string;
}

export function orphanedEdgeHandler(sourceId: string, activeVariants: Array<Variant>) {
    return async function removeOrphanedEdgesThunk(dispatch: Dispatch, getState: any) {
        const state = getState();
        const elements = state.journey?.journey?.elements;
        const NodeEdges: Array<Edge> = elements?.filter(
            (el: Edge) => el.type === "buttonedge" && el.source === sourceId
        );

        // If there are more edges than variants, we need to handle the new orphans
        if (NodeEdges?.length > activeVariants.length) {
            const activeIds = activeVariants.map((v) => v.previousId || v.id);

            const replaceVariants = activeVariants
                .filter((v) => !!v.previousId)
                .map((v) => [`${sourceId}-variant${v.previousId}`, `${sourceId}-variant${v.id}`]);

            const activeVariantIds: Array<string | undefined> = activeIds.map((id) => `variant${id}`);

            const removeEdges: Array<Edge> = NodeEdges?.filter((edge) => {
                const { source, sourceHandle } = edge;
                const edgeVariant = sourceHandle?.split(`${sourceId}-`).slice(-1)[0];
                return source === sourceId && !activeVariantIds.includes(edgeVariant);
            });

            const replaceEdges: Array<edgeReplacementRecords> = replaceVariants.map(
                ([variantSourceHandle, newSourceHandle]) => {
                    return {
                        edgeData: NodeEdges?.find((el) => el.sourceHandle == variantSourceHandle),
                        newHandle: newSourceHandle,
                    };
                }
            );

            const newEdges: Array<Edge | undefined> = isEmpty(replaceEdges)
                ? []
                : replaceEdges
                      .filter((r) => !!r.edgeData)
                      .map((e) => {
                          const { edgeData, newHandle } = e;
                          const nodeEdge = NodeEdges?.find((el) => el.id == edgeData?.id);
                          if (!!nodeEdge && !!edgeData) {
                              removeEdges.push(nodeEdge);
                              return createEdge({
                                  source: edgeData?.source,
                                  sourceHandle: newHandle,
                                  target: edgeData?.target,
                              });
                          }
                      });

            if (!isEmpty(removeEdges)) {
                dispatch(removeElements(removeEdges));
            }

            if (!isEmpty(newEdges)) {
                newEdges.forEach((edge) => {
                    if (!!edge) {
                        dispatch(addEdge(edge));
                    }
                });
            }
        }
    };
}

export function dropOutboundEdges(sourceId: string) {
    return async function dropOutboundEdgesThunk(dispatch: Dispatch, getState: any) {
        const state = getState();
        const elements = state.journey?.journey?.elements;
        const outboundEdges: Array<Edge> = elements?.filter(
            (el: Edge) => el.type === "buttonedge" && el.source === sourceId
        );

        if (!isEmpty(outboundEdges)) {
            dispatch(removeElements(outboundEdges));
        }
    };
}
